<template>
  <view class="radio-group-slot-demo">
    <view class="cube-radio-group-example">
      <cube-radio-group>
        <cube-radio
          wx:for="{{ options }}"
          wx:for-index="index"
          wx:for-item="option"
          wx:key="index"
          option="{{ option }}"
          wx:model="{{ checkedValue }}"
          wx:model-prop="value"
          ></cube-radio>
      </cube-radio-group>
    </view>
    <view class="view-desc">selected value: {{ checkedValue }}</view>
  </view>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  createComponent({
    options: {
      styleIsolation: 'shared'
    },
    data () {
      return {
        options: [
          {
            value: 'Option1',
            text: 'Option1'
          },
          {
            value: 'Option2',
            text: 'Option2'
          }
        ],
        checkedValue: 'Option1'
      }
    }
  })
</script>

<style lang="stylus">
.radio-group-slot-demo
  .cube-radio-group-example
    background-color #fff
    padding 5px 10px
  .desc
    margin-top 15px
</style>

<script type="application/json">
{
  "styleIsolation": "shared",
  "usingComponents": {
    "view-desc": "../../components/desc/index",
    "cube-radio": "@mpxjs/mpx-cube-ui/src/components/radio/index.mpx",
    "cube-radio-group": "@mpxjs/mpx-cube-ui/src/components/radio-group/index.mpx"
  }
}
</script>
